var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{attrs:{"id":"igPost"}},[_c('div',{staticClass:"elfsight-app-561b4294-d8e5-45df-acfe-139f37255313"})])}]

export { render, staticRenderFns }